import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { TradingChartLoader } from "@/components/TradingChartLoader";

export function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <TradingChartLoader
        fullScreen
        size="xl"
        text="Preparing your portal..."
        testId="loading-screen"
      />
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Admin can access ANY route (admin + student); student cannot access admin routes.
  if (role === "admin" && user.role !== "admin") {
    return <Navigate to="/student/dashboard" replace />;
  }

  return children;
}
